export default "<nav role=\"navigation\">\n  <ul class=\"breadcrumbs\">\n    <ng-content></ng-content>\n  </ul>\n</nav>\n";